import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children, requireAdmin = false, requireRoles }) {
  const { user, status, isAdmin } = useAuth();
  const location = useLocation();

  if (status === "loading") {
    return (
      <div
        style={{
          minHeight: "60vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontFamily: "'Outfit', sans-serif",
          color: "var(--afr-muted)",
        }}
        data-testid="protected-loading"
      >
        Chargement de votre session…
      </div>
    );
  }

  if (!user) {
    return (
      <Navigate
        to={`/login?next=${encodeURIComponent(location.pathname + location.search)}`}
        replace
      />
    );
  }

  if (requireAdmin && !isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  if (Array.isArray(requireRoles) && requireRoles.length > 0 && !requireRoles.includes(user.role)) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}
